import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-bar" }
const _hoisted_2 = { class: "search-wrap" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "filters" }
const _hoisted_5 = { class: "results-count" }

import BaseIcon from "@/components/ui/BaseIcon.vue";
import BaseSelect from "@/components/ui/BaseSelect.vue";
import type { SelectOption } from "@/components/ui/BaseSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersFilterBar',
  props: {
    search: {},
    status: {},
    loggedIn: {},
    total: {},
    filtered: {}
  },
  emits: ["update:search", "update:status", "update:loggedIn"],
  setup(__props: any, { emit: __emit }) {

const statusOptions: SelectOption[] = [
  { label: "Status", value: "all" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const loggedInOptions: SelectOption[] = [
  { label: "Logged In", value: "all" },
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseIcon, {
        name: "search",
        size: 14,
        class: "search-icon"
      }),
      _createElementVNode("input", {
        value: __props.search,
        class: "search-input",
        type: "text",
        placeholder: "Search users...",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (
          emit('update:search', ($event.target as HTMLInputElement).value)
        ))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BaseSelect, {
        "model-value": __props.status,
        options: statusOptions,
        icon: "filter",
        width: "130px",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:status', $event)))
      }, null, 8, ["model-value"]),
      _createVNode(BaseSelect, {
        "model-value": __props.loggedIn,
        options: loggedInOptions,
        width: "130px",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:loggedIn', $event)))
      }, null, 8, ["model-value"])
    ]),
    _createElementVNode("span", _hoisted_5, " Showing " + _toDisplayString(__props.filtered) + " of " + _toDisplayString(__props.total) + " users ", 1)
  ]))
}
}

})